export const iconFontAwesomeAnimalsDog = (
	<i className="fa-solid fa-dog"></i>
);
